import { render, staticRenderFns } from "./TablesStatus.vue?vue&type=template&id=3826f0a4&"
import script from "./TablesStatus.vue?vue&type=script&lang=js&"
export * from "./TablesStatus.vue?vue&type=script&lang=js&"
import style0 from "./TablesStatus.vue?vue&type=style&index=0&id=3826f0a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports